module.exports = __webpack_public_path__ + "img/football-helmet.dbe0ee90.svg";